
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.575 14.625H7.125A1.425 1.425 0 015.7 13.2c0-.044.011-1.132.876-2.2.497-.613 1.18-1.103 2.022-1.448 1.017-.42 2.279-.627 3.752-.627 1.473 0 2.731.212 3.752.627.842.345 1.521.831 2.022 1.447.869 1.07.876 2.153.876 2.201 0 .787-.638 1.425-1.425 1.425zM6.65 13.204c0 .26.215.471.475.471h10.45c.26 0 .475-.212.475-.471 0-.034-.03-.85-.701-1.648-.928-1.102-2.654-1.681-4.999-1.681-2.345 0-4.07.583-4.998 1.681-.672.798-.702 1.614-.702 1.648zM12.35 7.975a3.803 3.803 0 01-3.8-3.8c0-2.097 1.703-3.8 3.8-3.8 2.097 0 3.8 1.703 3.8 3.8 0 2.097-1.703 3.8-3.8 3.8zm0-6.65c-1.57 0-2.85 1.28-2.85 2.85s1.28 2.85 2.85 2.85 2.85-1.28 2.85-2.85-1.28-2.85-2.85-2.85zM4.275 14.625h-2.85A1.425 1.425 0 010 13.2c0-.033.007-.88.63-1.71.36-.48.85-.862 1.456-1.129.727-.323 1.621-.486 2.664-.486.17 0 .338.004.501.015a.474.474 0 01.449.5.474.474 0 01-.501.45 8.87 8.87 0 00-.449-.011c-3.7 0-3.796 2.26-3.8 2.378 0 .26.215.472.475.472h2.85a.474.474 0 110 .946zM4.75 8.925c-1.57 0-2.85-1.28-2.85-2.85s1.28-2.85 2.85-2.85 2.85 1.28 2.85 2.85-1.28 2.85-2.85 2.85zm0-4.75c-1.046 0-1.9.853-1.9 1.9 0 1.046.854 1.9 1.9 1.9 1.047 0 1.9-.854 1.9-1.9 0-1.047-.853-1.9-1.9-1.9z","fill":"#fff"}})])
          )
        }
      }
    